import './Form.css';
import vidio from "./12.MP4";

import Aos from "aos";
import 'aos/dist/aos.css';
import React, { useRef, useEffect } from "react";
import { useForm, ValidationError } from '@formspree/react';


export default function Form() {

    const videoRef = useRef(null);

    useEffect(() => {
      const videoElement = videoRef.current;
      if (videoElement) {
        videoElement.play().catch(error => {
          console.error('Error attempting to play video:', error);
        });
      }
    }, []);

    useEffect(() => {
        Aos.init();
      }, []);

    
    const [state, handleSubmit] = useForm("mzzpkoqo");

    if (state.succeeded) {

       return <div className="form-secc" id="contact">
            <h3>Form Submitted Successfully</h3>
            <p>Thank you for your submission. Our team will get in touch with you within 24 hours.</p>
       </div>;
    }

    return <section id="contact">

        <h2  data-aos="fade-up"  data-aos-duration="1000">Contact Us</h2>
        <h4  data-aos="fade-up"  data-aos-duration="1000">We're here to help with any questions or comments! Feel free to contact us by filling out this form. We will be more than happy to assist you.</h4>

        <div data-aos="fade-up"  data-aos-duration="1000" className='div-non-center'>
            <div className="cont-from">
                <div className="block-form block-2">
                
                    <video ref={videoRef} className="background-video" autoPlay loop muted playsInline onError={(e) => console.error('Ошибка загрузки видео:', e)}>
                        <source src={vidio} type="video/mp4" alt="from-vidio" /> 
                    </video>

                    <form onSubmit={handleSubmit}>

                        <div className="form-div">
                            <input type="text" name="name" id="full-name" placeholder="Full Name" required />
                        </div>

                        <div className="form-div">
                            <input type="email" name="_replyto" id="email-address" placeholder="Email Address" required />
                            <ValidationError prefix="Email" field="email" errors={state.errors}/>
                        </div>

                        <div className="form-div">
                            <input type="telephone" name="telephone" id="telephone" placeholder="Telephone Number (Optional)" />
                        </div> 

                        <div className="form-div">
                            <textarea rows="5" name="message" id="message" placeholder="Message"></textarea>
                            <ValidationError prefix="Message" field="message" errors={state.errors} />
                        </div>

                        <div className='form-div'>

                            <h6>Choose your services<sup>*</sup></h6>

                            <div className='radio-div'>
                                <label htmlFor="one">Open/Closed Pool</label>
                                <input type="radio" id="one" name="fav_language" value="Open/Closed Pool" />
                            </div>

                            <div className='radio-div'>
                                <label htmlFor="two">Standard Service</label>
                                <input type="radio" id="two" name="fav_language" value="Standard Service" /> 
                            </div>

                            <div className='radio-div'>
                                <label htmlFor="three">Luxury Service</label> 
                                <input type="radio" id="three" name="fav_language" value="Luxury Service" />    
                            </div>

                            <div className='radio-div'>
                                <label htmlFor="four">Additional Service</label> 
                                <input type="radio" id="four" name="fav_language" value="Additional Service" />
                            </div>

                            <div className='radio-div'>
                                <label htmlFor="five">Other</label> 
                                <input type="radio" id="five" name="fav_language" value="Other" />
                            </div>
                        </div>

                        <div className="form-div">
                            <button type="submit" disabled={state.submitting}>Submit</button>
                        </div>
                    </form>
                </div>

                <div className="block-form block-1">
                    <video ref={videoRef} className='des-vidio' autoPlay loop muted playsInline onError={(e) => console.error('Error Vidio', e)}>
                        <source src={vidio} type="video/mp4" alt="from-vidio" /> 
                    </video>
                </div>

            </div>
        </div>    
    </section>
}